import { render, staticRenderFns } from "./Yujiao.vue?vue&type=template&id=452b8b94&scoped=true&"
import script from "./Yujiao.vue?vue&type=script&lang=js&"
export * from "./Yujiao.vue?vue&type=script&lang=js&"
import style0 from "./Yujiao.vue?vue&type=style&index=0&id=452b8b94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452b8b94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
